import './App.css';
import React, {useEffect,useState} from "react";
import { collection, getDocs } from "firebase/firestore"; 
import {app,db} from "./Firebase/firebase"



export const List =(props)=>{
    const [Items, setItems] = useState([])
    const [SearchTerm, setSearchTerm] = useState('')
    const [FilteredItems, setFilteredItems] = useState([])
    const [type, setType] = useState("");

    function ABCSort(a,b){
      if(a.title < b.title) { return -1; }
      if(a.title > b.title) { return 1; }
      return 0;
    }
    const ChangeData =(text, typesel)=>{
     // let val =  e.target.value;
        //console.log(Items)
      let temp =[]
      //console.log(text)
      if (text =="") {
        //console.log("none")
        temp = (Items)
        //setFilteredItems(Items) 
      }
      else{
        temp =Items.filter(e => {
         // console.log(e.title.toLowerCase() === text.toLowerCase())
          return e.title.toLowerCase().includes(text.toLowerCase());
        })
        //console.log(temp)
      }
   
      if (typesel==""){
        //console.log("no filter")
      //do nothing
      }
      else{
        temp=  temp.filter(v => v.type == typesel)
    
       }
       temp.sort((a,b)=>ABCSort(a,b))
        setFilteredItems([...temp])
      }
    const FilterBySelect=(arr, selectedval)=>{

    }

    const getLinks=async()=>{
      let arr = [];
      const querySnapshot = await getDocs(collection(db, "Posts"));
      querySnapshot.forEach((doc) => {
        //console.log(`${doc.id} => ${doc.data()}`);
        arr.push(doc.data());
      });
      return(arr)
    }
  
    const handleTypeChange =(e)=>{
     setType(e.target.value)
     //console.log(SearchTerm)
    ChangeData(SearchTerm, e.target.value)
    
    
    }
    const handletxtChange=(e)=>{
        let text =  e.target.value;
        //console.log(e, type)
        ChangeData(text,type)
        setSearchTerm(text)
    }

    useEffect( async()=>{
        let temp = await getLinks();
        temp.sort((a,b)=>ABCSort(a,b))
        setItems(temp)
        setFilteredItems(temp)
        //console.log(temp)
      },[])

    return(<div className="container">
        
        <div>
          <div className='ad'>
          <iframe src="//a.exdynsrv.com/iframe.php?idzone=4652970&size=300x100" width="300" height="100" scrolling="no" marginwidth="0" marginheight="0" frameborder="0"></iframe>
          This is an AD to keep This service up and running
          </div>
        <h3>Posts</h3>
        <div className="input-group mb-3">
        <input className="form-control" placeholder="search" onChange={(e)=>handletxtChange(e)}/>
        <select className="form-select" value={type} onChange={(e)=>handleTypeChange(e)}>
      <option value ="">All</option>
        <option value ="Demo">Demostration</option>
        <option value="Guide">Guide</option>
        <option value="Routine">Routine</option>
        <option value="Youtube">Youtube</option>
        <option value = "Hink">Doc Hink</option>
        <option value ="Other">Other</option>
      </select>
        </div>
        <br></br>
        <div >
         
            <div className="grid-row">
            <div className=""><strong>Item</strong></div>
            <div className=""><strong>Type</strong></div>
            </div>
           
          
          

          

       {FilteredItems.map((v,k)=>{

          if( k % 30 ==0 && k != 0 ){
            return(
              <div>
             <div className="grid-row" style={{padding: ".5em", borderBottom: "black 1px solid"}} key = {k}>
               <div className="">
                <a href= {v.link}> {v.title}</a>
               </div>
               <div className="smol">
                 {v.type}
               </div>
             </div>
             <AdRow/>
  
              </div>  
             )
          }
          else{
            return(
              <div>
             <div className="grid-row" style={{padding: ".5em", borderBottom: "black 1px solid"}} key = {k}>
               <div className="">
                <a href= {v.link}> {v.title}</a>
               </div>
               <div className="smol">
                 {v.type}
               </div>
             </div>           
              </div>  
             )
          }

       })}
           
           Showing {FilteredItems.length} Articles
           </div>
      </div>

       
     

    </div>)
}

export const  AdRow=()=>{
 return( <div className="grid-row" >
   <div className="ad">
   <iframe src="//a.exdynsrv.com/iframe.php?idzone=4652958&size=300x100" width="300" height="100" scrolling="no" marginwidth="0" marginheight="0" frameborder="0"></iframe>
   This ad is to keep this service up and running
   </div>
  
 </div>

 )
}